import { render, staticRenderFns } from "./partnerCard.vue?vue&type=template&id=95d6f474&scoped=true&"
import script from "./partnerCard.vue?vue&type=script&lang=js&"
export * from "./partnerCard.vue?vue&type=script&lang=js&"
import style0 from "./partnerCard.vue?vue&type=style&index=0&id=95d6f474&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95d6f474",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('95d6f474')) {
      api.createRecord('95d6f474', component.options)
    } else {
      api.reload('95d6f474', component.options)
    }
    module.hot.accept("./partnerCard.vue?vue&type=template&id=95d6f474&scoped=true&", function () {
      api.rerender('95d6f474', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ClientDashboard/collaborators/partnerCard.vue"
export default component.exports